"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GCPServiceAccountKeySchema = exports.VertexAIConfigSchema = exports.BedrockCredentialSchema = exports.BedrockApiKeySchema = exports.BedrockAccessKeysSchema = exports.OpenAIConfigSchema = exports.LLMConnectionConfigSchema = exports.LLMConnectionConfigValueSchema = exports.BedrockConfigSchema = exports.VERTEXAI_USE_DEFAULT_CREDENTIALS = exports.BEDROCK_USE_DEFAULT_CREDENTIALS = void 0;
const zod_1 = require("zod");
// Sentinel value for Bedrock default credential provider chain
exports.BEDROCK_USE_DEFAULT_CREDENTIALS = "__BEDROCK_DEFAULT_CREDENTIALS__";
// Sentinel value for Vertex AI default credential provider chain (ADC)
exports.VERTEXAI_USE_DEFAULT_CREDENTIALS = "__VERTEXAI_DEFAULT_CREDENTIALS__";
exports.BedrockConfigSchema = zod_1.z.object({ region: zod_1.z.string() });
exports.LLMConnectionConfigValueSchema = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.boolean(),
]);
exports.LLMConnectionConfigSchema = zod_1.z.record(zod_1.z.string(), exports.LLMConnectionConfigValueSchema);
exports.OpenAIConfigSchema = zod_1.z
    .object({
    useResponsesApi: zod_1.z.boolean().default(false),
})
    .strict();
exports.BedrockAccessKeysSchema = zod_1.z
    .object({
    accessKeyId: zod_1.z.string().min(1),
    secretAccessKey: zod_1.z.string().min(1),
})
    .strict();
exports.BedrockApiKeySchema = zod_1.z
    .object({
    apiKey: zod_1.z.string().min(1),
})
    .strict();
exports.BedrockCredentialSchema = zod_1.z.union([
    exports.BedrockAccessKeysSchema,
    exports.BedrockApiKeySchema,
]);
exports.VertexAIConfigSchema = zod_1.z
    .object({
    location: zod_1.z.string().optional(),
})
    .strict();
exports.GCPServiceAccountKeySchema = zod_1.z.object({
    type: zod_1.z.literal("service_account"),
    project_id: zod_1.z.string(),
    private_key_id: zod_1.z.string(),
    private_key: zod_1.z.string(),
    client_email: zod_1.z.string(),
    client_id: zod_1.z.string(),
    auth_uri: zod_1.z.string(),
    token_uri: zod_1.z.string(),
    auth_provider_x509_cert_url: zod_1.z.string(),
    client_x509_cert_url: zod_1.z.string(),
});
